// The words the chart screens share (docs/plans/phase2-medical-records-charts.md §6). One
// name for each state everywhere.
import type { ChartMovementKind } from '@wodi/domain';
import type { ChartPlace } from '@wodi/shared';
import type { TagState } from '@wodi/ui';

export const MOVEMENT_WORDS: Record<ChartMovementKind, string> = {
  filed: 'Filed',
  issued: 'Issued',
  returned: 'Returned',
};

/** Where a chart is or went, in words: "Records room, Shelf A3", "Ward: Maternity ward". */
export function placeWords(place: ChartPlace): string {
  switch (place.kind) {
    case 'location':
      return `${place.room}, ${place.label}`;
    case 'ward':
      return `Ward: ${place.name}`;
    case 'service_point':
      return `Department: ${place.name}`;
  }
}

export function chartStateTag(now: { state: 'in' | 'out'; overdue: boolean }): [string, TagState] {
  if (now.state === 'in') return ['In the records room', 'done'];
  return now.overdue ? ['Overdue', 'attention'] : ['Out', 'active'];
}

export function returnPeriodWords(hours: number | null): string {
  if (hours === null) return 'Return period not set up';
  return hours === 1 ? 'Due back within 1 hour' : `Due back within ${String(hours)} hours`;
}
